(function($) {
  	
	$(document).ready(function() {		
		planetx.init();
	});

	var planetx = {
        planetxTimeout: null,
		isSidebarAjaxClick: false,
		init: function() {			
			this.window_resize();
			this.search_toggle();	
			this.header_fixed();
			this.slider();
			this.fixed_img();
			this.product_list_slider();
			this.dropdown();
			//this.testimonials();
			this.initSliders();
			this.wow_animation();
			this.grid_height();
			this.alert_css();
			this.cart_qty();
		},
		
		cart_qty:function() {
          //on cart page
            $("body").on('click', '.plus', function() {			
				var getval = $(this).prev().val();
				getval++;
				$(this).prev().val(getval);
				$("#update-cart").trigger('click');
			});
          	$("body").on('click', '.minus', function() {
				var getval = $(this).next().val();
				if(getval > 1){
					getval--;
					$(this).next().val(getval);
					$("#update-cart").trigger('click');
				}
			});
        },   

		alert_css: function(){
      		window.alert = function(message) { $('#messageBox').text(message).fadeIn().delay(4000).fadeOut('slow'); }
    	},

		window_resize: function(){
			$(window).load(function(){
				planetx.resizeContent();   
					
				$(window).resize(function() {
					planetx.resizeContent();
				});
			});

		},
		
		resizeContent: function(){
	
			header_height = $('#header').height()
			features_banner = $(window).height() - header_height;
			$('.features-banner, #page_banner, #connect_banner').css('height' , features_banner);
		},
		
		search_toggle: function(){
			$(".sub_nav .search-icon").click(function(e) {
				$('.sub_nav .search-icon').toggleClass('expand_search');
			});
			
			$('html').click(function() {
				$('.sub_nav .search-icon').removeClass('expand_search');
			});
			
			$('.sub_nav .search-icon,.sub_nav .search-icon input').click(function(event){
				event.stopPropagation();
			});
		},		
		
		//====================================  HEADER
		
		header_fixed: function(){			
			
			/*======   mean menu  =======*/
			
			jQuery('header nav').meanmenu();
			
			/*======   fixed header  =======*/
			
			var didScroll;
			var lastScrollTop = 0;
			var delta = 5;
			var navbarHeight = $('header').outerHeight();
		
			$(window).scroll(function(event){
			  didScroll = true;
			});
			
			setInterval(function() {
			  if (didScroll) {
				hasScrolled();
				didScroll = false;
			  }
			}, 250);
			hasScrolled();
			
			function hasScrolled() {
			  var st = $(this).scrollTop();
		
			  if(Math.abs(lastScrollTop - st) <= delta)
				return;
			  if (st > lastScrollTop && st > navbarHeight){
				$('header').removeClass('nav-down').addClass('nav-up');
			  } else {
				if(st + $(window).height() < $(document).height()) {
				  if(st==0){
					$('header').removeClass('nav-up').removeClass('nav-down');
				  }
				  else{
					$('header').removeClass('nav-up').addClass('nav-down');
				  }
				}
			  }
			  lastScrollTop = st;
			}
		},
	
	
	    //================  BX SLIDER
		slider: function(){
			$('.bxslider').bxSlider({
			  mode: 'fade',
			  captions: true
			});
			$('.large_img').bxSlider({
			  pagerCustom: '#bx-pager',
			  captions: false,
			  controls:false,
			});
		},
		
		 //================  CHILLER IMAGE
		 
		 fixed_img: function(){
			var fixed_menu = true;
			window.jQuery = window.$ = jQuery;	
            
            /*var waypoint = new Waypoint({
              element: document.getElementById('bottom-in-view-example'),
              handler: function(direction) {
                console.log(this.element.scrollTop)
              },
              offset: function() {
                return this.element.offsetTop;
              }
            });*/
          /* $(window).scroll(function() {
             var get_img_po = $('.chiller-img').offset().top;
             //console.log(get_img_po);

             var get_btn_po = $('#bottom-in-view-example').offset().top;
             //console.log(get_btn_po);
             var get_btn_h = $('#bottom-in-view-example').height();
             var final_offset =  get_btn_po - get_img_po;
             console.log(jQuery(window).scrollTop());
             console.log(final_offset);
             if (jQuery(window).scrollTop() > final_offset) {
               jQuery('.chiller-img').addClass('fixed_show');

             }
             else {
               jQuery('.chiller-img').removeClass('fixed_show');
             }
             
           });*/
            setInterval(function(){
			if($(window).width() >= 1025 && $(window).width() <= 1290){
				if (jQuery(window).scrollTop() > 475) {
				  jQuery('.chiller-img').addClass('fixed_show');
				  
				 }
				 else {
				  jQuery('.chiller-img').removeClass('fixed_show');
				 }
			}
              
			else{
				 if (jQuery(window).scrollTop() > 590) {
				  jQuery('.chiller-img').addClass('fixed_show');
				  
				 }
				 else {
				  jQuery('.chiller-img').removeClass('fixed_show');
				 }
				}
			},0);

			
				
			
		 },
		 
		 //==========================   QUANTITY SELECT
		 
		 qnt_select:function(){

			 $('.plus').click(function(){
				var getval = $('#quantity').val();
				getval++;
				$('#quantity').val(getval);
				
			  });
			
			$('.minus').click(function(){
				var getval = $('#quantity').val();
					if(getval > 1)
					{
					getval--;
					}
					$('#quantity').val(getval);
				  		

			});
				
		 },
		 grid_height:function(){
		// 	$('.product_list.grid .product_item .product_img').responsiveEqualHeightGrid();
		 },

		 product_list_slider:function() {
            //==================  RELATED - PRODUCT LIST
			
			$('#shop_accessories .product_list, #related_products .product_list').owlCarousel({
			  loop:false,
			  nav:false,
			  dots:false,
			  responsive:{
				  0:{
					items:1,
					dots:true,
				  },
				  480:{
					items:2,
					dots:true,
					margin:12,
				  },
				  767:{
					items:2,
					dots:true,
					margin:12,
				  },
				  768:{
					items:3,
					margin:20,
				  },
				  991:{
					items:3,
					margin:25,
				  },
				  992:{
					items:4,
					margin:25,
				  },
				  1024:{
					items:4,
					margin:30,
				  }     
			  }
			});
          
        },
		
		 dropdown:function() {
			$(".first-drp").heapbox();
			$(".snd-drp").heapbox();
		 },
		 
		 testimonials:function(){
		  $('.center').slick({
			  centerMode: true,
			  centerPadding: '0px',
			  slidesToShow: 3,
			  responsive: [
				{
				  breakpoint: 992,
				  settings: {
					centerMode: true,
					centerPadding: '130px',
					slidesToShow: 1
				  }
				},
				{
				  breakpoint: 767,
				  settings: {
					centerMode: true,
					centerPadding: '0px',
					slidesToShow: 1
				  }
				}
			  ]
			});

		  	$('.slick-track').height($('.testimonials_item').outerHeight());

		  	// If only three slide
			if($(window).width() > 992){
		  	var length_slide = $('.slick-track .testimonials_item').length;
		  	if(length_slide == 3){
		  		$('.slick-list').before('<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" role="button" style="display: block;">Previous</button>');
				$('.slick-list').after('<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" role="button" style="display: block;">Next</button>');
		  		$('.slick-track .testimonials_item:nth-child(1)').removeClass('slick-current slick-center');
		  		$('.slick-track .testimonials_item:nth-child(2)').addClass('slick-current slick-center');
		  	};
		  	
		  	$('.slick-prev').click(function(){
				var current_index = $('.slick-track .slick-current').index();
				$('.slick-track .testimonials_item').eq(current_index-1).addClass('slick-current slick-center');
				$('.slick-track .testimonials_item').eq(current_index).removeClass('slick-current slick-center');
		  		
		  	});

		  	$('.slick-next').click(function(){
		  		var current_index = $('.slick-track .slick-current').index();
				$('.slick-track .testimonials_item').eq(current_index+1).addClass('slick-current slick-center');
				$('.slick-track .testimonials_item').eq(current_index).removeClass('slick-current slick-center');
		  		
		  	});

		  	$('.slick-track .testimonials_item').click(function(){
		  		$(this).siblings().removeClass('slick-current slick-center');
		  		$(this).addClass('slick-current slick-center');
		  	});
			}
		 },

		 initSliders:function(){
		 	var $slider = $('.testimonials .carousel');
		 	if ($slider.length > 0) {
                    $slider.each(function(obj) {
                        // bind slider options to HTML5 data-attributes
                        var $slider = $(this),
                            sliderGallerySize = $slider.attr('data-gallery-size'),
                            sliderCellAlign = $slider.attr('data-align'),
                            sliderContain = $slider.attr('data-contain'),
                            sliderAdaptiveHeight = $slider.attr('data-auto-height'),
                            sliderDots = $slider.attr('data-dots'),
                            sliderArrows = $slider.attr('data-arrows'),
                            sliderScroll = $slider.attr('data-freescroll'),
                            sliderAutoPlay = $slider.attr('data-autoplay'),
                            sliderWrapAround = $slider.attr('data-endless'),
                            sliderAdaptiveHeight = $slider.attr('data-auto-height'),
                            sliderAsNavFor = $slider.attr('data-nav'),
                            sliderGroupCells = $slider.attr('data-group-cells'),
                            sliderInitialIndex = $slider.attr('data-index'),
                            $sliderCell = $slider.find('.carousel-cell');


                        if (!sliderCellAlign) {
                            sliderCellAlign = 'center';
                        }
                        if (!sliderGallerySize || sliderGallerySize == 'true') {
                            sliderGallerySize = true;
                        } else {
                            sliderGallerySize = false;
                        }
                        if (!sliderContain || sliderContain == 'false') {
                            sliderContain = false;
                        } else {
                            sliderContain = true;
                        }
                        if (!sliderAdaptiveHeight || sliderAdaptiveHeight == 'false') {
                            sliderAdaptiveHeight = false;
                        } else {
                            sliderAdaptiveHeight = true;
                        }
                        if (!sliderDots || sliderDots == 'false') {
                            sliderDots = false;
                        } else {
                            sliderDots = true;
                        }
                        if (!sliderArrows || sliderArrows == 'false') {
                            sliderArrows = false;
                        } else {
                            sliderArrows = true;
                        }
                        if (!sliderWrapAround || sliderWrapAround == 'false') {
                            sliderWrapAround = false;
                        } else {
                            sliderWrapAround = true;
                        }
                        if (!sliderScroll || sliderScroll == 'false') {
                            sliderScroll = false;
                        } else {
                            sliderScroll = true;
                        }
                        if (!sliderAdaptiveHeight || sliderAdaptiveHeight == 'false') {
                            sliderAdaptiveHeight = false;
                        } else {
                            sliderAdaptiveHeight = true;
                        }
                        if (!sliderAutoPlay || sliderAutoPlay == 'false') {
                            sliderAutoPlay = false;
                        }

                        $slider.flickity({
                            cellSelector: '.carousel-cell',
                            contain: sliderContain,
                            cellAlign: sliderCellAlign,
                            setGallerySize: sliderGallerySize,
                            adaptiveHeight: sliderAdaptiveHeight,
                            pageDots: sliderDots,
                            prevNextButtons: sliderArrows,
                            wrapAround: sliderWrapAround,
                            asNavFor: sliderAsNavFor,
                            groupCells: sliderGroupCells,
                            freeScroll: sliderScroll,
                            adaptiveHeight: sliderAdaptiveHeight,
                            autoPlay: sliderAutoPlay,
                            pauseAutoPlayOnHover: true,
                            imagesLoaded: true,
                            initialIndex: sliderInitialIndex,
                            lazyLoad: true,
                            dragThreshold: 20,
                            selectedAttraction: 0.04,
                            friction: 0.3
                        });

                        // hide nav UI if only one slide available
                        if ($sliderCell.length < 2) {
                            $slider.addClass('hide-nav-ui');
                        }

                        function updateSlide() {
                            var flkty = $(this).data('flickity');
                            var activeElement = flkty.selectedElement;
                            var activeSlide = $(activeElement);
                            var animationEffect = $(activeElement).attr('data-animation');
                            var activeCaption = activeSlide.find('.caption-container');
                            var activeVideo = activeSlide.find('video');

                            // if animation effect exists to slide => add animation classes to captions (children elements)
                            if (animationEffect) {
                                $('.caption-item').each(function(index, obj) {
                                    $(this).addClass('animated collapse _' + index);
                                });
                            }
                            if (activeCaption.length != 0) {
                                //console.log(activeSlide);
                                $('.caption-container .animated').fadeOut();
                                activeSlide.find('.animated').show().addClass(animationEffect);
                            }
                            if (activeVideo.length != 0) {
                                activeVideo[0].play();
                            }
                        }
                        $slider.on('select.flickity', updateSlide);
                        $slider.flickity('select', 0);
                    });
                }
		 },
		 
		 wow_animation:function(){
		 	new WOW().init();
		 }		 
	
    }
			
})(jQuery);		



setTimeout(function(){ 
	$("#_liveChatFrame").contents().find(".new-bubble--bubble").css({"background-color": "#ea8400"});
}, 3000);


$('a[href*="#"]:not([href="#"])').click(function() {
  if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
    if (target.length) {
      $('html, body').animate({
        scrollTop: target.offset().top
      }, 1000);
      return false;
    }
  }
});




$('html').click(function() {
	$('.meanclose').trigger('click');
 	
});

$('body').on('click','.meanmenu-reveal,.mean-nav', function(event){
	event.stopPropagation();
});

